import React, { createContext, useContext, useMemo, useEffect } from "react";

const separator = " | ";

const tokensContext = createContext<string[]>([]);

/*******
 * Set the document title with a nestable component that pushes the next value onto a stack
 */
type Props = {
   title: string;
   children?: React.ReactNode;
};
export const DocumentTitle = ({ title, children }: Props): JSX.Element => {

   const baseTokens = useContext<string[]>(tokensContext);

   const allTokens = useMemo<string[]>(() => {
      if (title === "") {
         return baseTokens;
      }
      return [title, ...baseTokens]; // Put the new token at the start
   }, [title, baseTokens]);


   function setTitle(newTitle: string): void {
      document.title = newTitle;
   }

   // Set the doc title when the title param changes
   useEffect(() => setTitle(allTokens.join(separator)), [allTokens]);

   // On unmount, reset the title to the base stack
   useEffect(() => {
      return () => setTitle(baseTokens.join(separator));
   }, []);

   return (
      <tokensContext.Provider value={allTokens}>
         <>
            {setTitle(allTokens.join(separator)) /* Set immediately before a child sets it */}
            {children}
         </>
      </tokensContext.Provider>
   );
}